import React from 'react';
import {
  summarizeBatchSettleBlock,
  getParticipantBlockReasonRows,
  getBirthDateFromRrn,
} from '../utils/settleBlockMessages';

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
  },
  modal: {
    background: 'white',
    padding: '30px',
    borderRadius: '10px',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
  },
  header: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#d9534f',
    marginBottom: '20px',
  },
  summaryBox: {
    background: '#fff5f5',
    border: '1px solid #f5c6cb',
    borderRadius: '6px',
    padding: '12px 14px',
    marginBottom: '16px',
    fontSize: '0.95rem',
    lineHeight: 1.6,
  },
  bullet: {
    margin: '4px 0',
    color: '#721c24',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '8px',
  },
  th: {
    border: '1px solid #ddd',
    padding: '10px',
    background: '#f4f4f4',
    textAlign: 'left',
    fontSize: '0.9rem',
  },
  td: {
    border: '1px solid #ddd',
    padding: '8px',
    fontSize: '0.85rem',
    verticalAlign: 'top',
  },
  closeButton: {
    padding: '10px 20px',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    marginTop: '20px',
    width: '100%',
  },
};

const SettleBlockModal = ({ invalidParticipants, onClose }) => {
  if (!invalidParticipants?.length) return null;

  const { headline, bullets, actionHint } = summarizeBatchSettleBlock(invalidParticipants);

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={modalStyles.header}>⚠️ 정산 불가 안내</div>

        <div style={modalStyles.summaryBox}>
          <div style={{ fontWeight: 'bold', marginBottom: bullets.length ? '8px' : 0 }}>
            {headline}
          </div>
          {bullets.map((b) => (
            <div key={b.type} style={modalStyles.bullet}>
              · {b.text}
            </div>
          ))}
        </div>

        <p style={{ marginBottom: '12px', color: '#666', fontSize: '0.9rem' }}>{actionHint}</p>

        <table style={modalStyles.table}>
          <thead>
            <tr>
              <th style={modalStyles.th}>성명</th>
              <th style={modalStyles.th}>생년월일</th>
              <th style={modalStyles.th}>참여기간</th>
              <th style={modalStyles.th}>사유</th>
            </tr>
          </thead>
          <tbody>
            {invalidParticipants.map((p) => {
              const reasons = getParticipantBlockReasonRows(p);
              return (
                <tr key={p.participantId}>
                  <td style={{ ...modalStyles.td, fontWeight: 'bold' }}>{p.name}</td>
                  <td style={modalStyles.td}>{getBirthDateFromRrn(p.rrn)}</td>
                  <td style={modalStyles.td}>
                    {p.hasMissingEndDate
                      ? `${p.startDate || '-'} ~ (종료일 없음)`
                      : `${p.startDate} ~ ${p.endDate}`}
                  </td>
                  <td style={modalStyles.td}>
                    {reasons.map((r) => (
                      <div key={r.key} style={{ marginBottom: '6px' }}>
                        <strong>{r.label}:</strong> {r.detail}
                      </div>
                    ))}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <button type="button" style={modalStyles.closeButton} onClick={onClose}>
          확인
        </button>
      </div>
    </div>
  );
};

export default SettleBlockModal;
